import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import CallbackForm from "./CallbackForm";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_372c5601-80d9-473d-b6d0-4867dee1eff7/artifacts/vozwpjh6_logo.webp";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [callbackOpen, setCallbackOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { href: "/", label: "Главная" },
    { href: "/#products", label: "Товары" },
    { href: "/instructions", label: "Инструкция" },
    { href: "/claims", label: "Рекламации" },
  ];

  const isActive = (href) => {
    if (href === "/") return location.pathname === "/";
    return location.pathname === href || location.hash === href.replace("/", "");
  };

  return (
    <header className="header-glass sticky top-0 z-50" data-testid="header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0" data-testid="logo-link">
            <img
              src={LOGO_URL}
              alt="BE KIDS"
              className="h-12 w-auto"
              data-testid="logo-image"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`nav-link ${isActive(link.href) ? "active" : ""}`}
                data-testid={`nav-link-${link.label.toLowerCase()}`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center space-x-4">
            <Dialog open={callbackOpen} onOpenChange={setCallbackOpen}>
              <DialogTrigger asChild>
                <Button
                  className="btn-primary flex items-center gap-2"
                  data-testid="callback-btn"
                >
                  <Phone className="w-4 h-4" />
                  Заказать звонок
                </Button>
              </DialogTrigger>
              <DialogContent className="sm:max-w-md z-[100]" data-testid="callback-dialog">
                <DialogHeader>
                  <DialogTitle className="heading-3">Заказать обратный звонок</DialogTitle>
                </DialogHeader>
                <CallbackForm onSuccess={() => setCallbackOpen(false)} />
              </DialogContent>
            </Dialog>
          </div>

          {/* Mobile menu button */}
          <button
            className="md:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-btn"
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6 text-[#1A1A1A]" />
            ) : (
              <Menu className="w-6 h-6 text-[#1A1A1A]" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-[#1A1A1A]/5" data-testid="mobile-nav">
            <nav className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`nav-link py-2 ${isActive(link.href) ? "active" : ""}`}
                  onClick={() => setMobileMenuOpen(false)}
                  data-testid={`mobile-nav-link-${link.label.toLowerCase()}`}
                >
                  {link.label}
                </Link>
              ))}
              <Dialog open={callbackOpen} onOpenChange={setCallbackOpen}>
                <DialogTrigger asChild>
                  <Button
                    className="btn-primary flex items-center justify-center gap-2 mt-4"
                    data-testid="mobile-callback-btn"
                  >
                    <Phone className="w-4 h-4" />
                    Заказать звонок
                  </Button>
                </DialogTrigger>
              </Dialog>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
